import { useIntl } from 'react-intl';
import './style.scss';

const LoadingIndicator = ({ hideText }: { hideText?: boolean }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="loading-indicator">
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader loader2"></div>
        <div className="loader loader3"></div>
        <div className="loader loader4"></div>
        {!hideText && <span className="loader-container__text">{formatMessage({ id: 'generic.loading' })}</span>}
      </div>
    </div>
  );
};
export default LoadingIndicator;
